var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_27050)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1213 1.87868C14.4633 2.22063 14.7213 2.80067 14.86 4.01708C14.9984 5.23148 15 6.87049 15 9.17157C15 10.699 14.9969 11.7253 14.8667 12.5203C14.7456 13.2598 14.5256 13.717 14.1213 14.1213C13.7523 14.4903 13.2342 14.7309 12.2558 14.8625C11.2487 14.9979 9.91389 15 8 15C6.08611 15 4.75129 14.9979 3.74416 14.8625C2.76579 14.7309 2.2477 14.4903 1.87868 14.1213C1.50966 13.7523 1.26907 13.2342 1.13753 12.2558C1.00212 11.2487 1 9.91389 1 8C1 6.08611 1.00212 4.75129 1.13753 3.74416C1.26907 2.76579 1.50966 2.2477 1.87868 1.87868C2.2477 1.50966 2.76579 1.26907 3.74416 1.13753C4.75129 1.00212 6.08611 1 8 1C9.91389 1 11.2487 1.00212 12.2558 1.13753C13.2342 1.26907 13.7523 1.50966 14.1213 1.87868ZM14.8284 1.17157C16 2.34315 16 4.61929 16 9.17157C16 12.1618 16 13.6569 14.8284 14.8284C13.6569 16 11.7712 16 8 16C4.22876 16 2.34315 16 1.17157 14.8284C0 13.6569 0 11.7712 0 8C0 4.22876 0 2.34315 1.17157 1.17157C2.34315 0 4.22876 0 8 0C11.7712 0 13.6569 0 14.8284 1.17157ZM11.5172 6.5431C11.8172 6.25744 11.8288 5.78271 11.5431 5.48276C11.2574 5.18281 10.7827 5.17123 10.4828 5.4569L6.8 8.96429L5.51724 7.74261C5.21729 7.45695 4.74256 7.46853 4.4569 7.76847C4.17123 8.06842 4.18281 8.54315 4.48276 8.82882L6.28276 10.5431C6.57241 10.819 7.02759 10.819 7.31724 10.5431L11.5172 6.5431Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.64aa374ada054f92a1b08a2329233b42.svg";
export { ForwardRef as ReactComponent };